import React from "react";
import { useNavigate } from "react-router-dom";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';





function PageNotFound() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/home");
  };
  const HandleContact = () => {
    navigate("contact-us");
  };
  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <DotLottieReact
            src="https://lottie.host/80fe07d6-a525-43e6-b93a-eb851815ae27/df7MCafJtE.lottie"
            loop
            autoplay
          />
          <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
            Page not found
          </h1>
          <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="#"
              onClick={handleBack}
              className="rounded-md bg-[#5FBDB3] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#5FBDB3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Go back home
            </a>
            <a
              href="#"
              className="text-sm font-semibold text-gray-900"
              onClick={HandleContact}
            >
              Contact support <span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
export default PageNotFound;
